
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from 'src/app/services/auth/auth.service';

interface ContactOption {
  title: string;
  description: string;
  icon: string;
  route?: string;
  action?: () => void;
  requiredRoles?: string[];
  rbacPermissions?: string[];
}

@Component({
  selector: 'app-create-contact',
  templateUrl: './create-contact.component.html',
  styleUrls: []
})
export class CreateContactComponent implements OnInit {
   contactOptions: ContactOption[] = [];

   // RBAC: controla visibilidad de búsqueda y lista
   canSearch: boolean = true;
   canListContacts: boolean = true;

   // Propiedades para el formulario de búsqueda integrado
   searchForm: FormGroup;
   searchLoading: boolean = false;
   searchSubmitted: boolean = false;
   clientNotFound: boolean = false;
   type_identity: any[] = [];
   code_identity: any[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user:UserService,
    private sanitizer: DomSanitizer,
    public _auth : AuthService,
    private formBuilder: FormBuilder

  ) {
    // Inicializar el formulario de búsqueda
    this.searchForm = this.formBuilder.group({
      type_identity: ['CI', [Validators.required]],
      code_identity: ['V', [Validators.required]],
      identity: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(8)]]
    });
  }

  ngOnDestroy(): void {

  }

  ngOnInit(): void {
    // RBAC: verificar permisos granulares
    if (this._auth.hasRbac$.getValue()) {
      this.canSearch = this._auth.hasAnyPermission(['contactos.busqueda.read']);
      this.canListContacts = this._auth.hasAnyPermission(['contactos.lista_contactos.read']);
    }

    this.contactOptions = [
      {
        title: 'Lista de Contactos',
        description: 'Visualiza todos los contactos registrados con opciones de filtrado y gestión',
        icon: 'fas fa-users',
        route: '/console/constacts',
        requiredRoles: ['OWNER', 'ANALIST', 'EJECUTIVE', 'ADMIN', 'FINANCIAL'],
        rbacPermissions: ['contactos.lista_contactos.read']
      }
    ];

    // Cargar las listas para el formulario de búsqueda
    this.loadSearchFormData();
  }

  // Método para cargar datos del formulario de búsqueda
  loadSearchFormData = async () => {
    try {
      const [type_identity, code_identity] = await Promise.all([
        this._user.getPersonTypeIdentity(),
        this._user.getPersonCodeIdentity()
      ]);

      this.type_identity = type_identity.resp;
      this.code_identity = code_identity.resp;
    } catch (error) {
      console.error('Error loading search form data:', error);
    }
  }

  // Método para realizar la búsqueda
  searchClient = async () => {
    if (!this.searchForm.valid) return;

    this.searchLoading = true;
    this.searchSubmitted = true;
    this.clientNotFound = false;

    try {
      const searchData = this.searchForm.getRawValue();
      const response = await this._user.getPersonByIdentifier(searchData);

      if (response && response.resp) {
        // Redirección automática al perfil del cliente
        this.router.navigate(['/console/person/profile', response.resp.person?.code]);
      } else {
        this.clientNotFound = true;
      }
    } catch (error) {
      console.error('Error searching client:', error);
      this.clientNotFound = true;
    } finally {
      this.searchLoading = false;
    }
  }

  // Método para limpiar la búsqueda
  clearSearch = () => {
    this.searchForm.reset({
      type_identity: 'CI',
      code_identity: 'V',
      identity: ''
    });
    this.searchSubmitted = false;
    this.clientNotFound = false;
  }

  hasPermission(option: ContactOption): boolean {
    if (this._auth.hasRbac$.getValue()) {
      if (option.rbacPermissions && option.rbacPermissions.length > 0) {
        return this._auth.hasAnyPermission(option.rbacPermissions);
      }
      return this._auth.hasModuleAccess('contactos');
    }
    if (!option.requiredRoles || option.requiredRoles.length === 0) return true;
    return option.requiredRoles.some(role => this._auth.sessionUser?.profile?.includes(role));
  }
}
